"use client";
import { useEffect, useRef, useState } from "react";
import "./style.css"
import howtoplay from "../../assets/images/htp.png"
import howtoplayBTN from "../../assets/images/howtoplayBTN.svg"


export default function Rules({ rules = [] }) {
  const containerRef = useRef(null);
  const cardsRef = useRef([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(4);

  // Transform rules array into card data format
  const cardData = rules.map((rule, index) => {
    return {
      no: (index + 1).toString().padStart(2, '0'),
 text: rule.content || rule.rule || "",

      image: rule.image || ""
    };
  });

  const getCardsPerView = () => {
    if (window.innerWidth < 576) return 1;
    if (window.innerWidth < 768) return 2;
    if (window.innerWidth < 992) return 3;
    return 4;
  };

  useEffect(() => {
    const handleResize = () => {
      setCardsPerView(getCardsPerView());
      setCurrentIndex(0);
    };

    setCardsPerView(getCardsPerView());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!cardsRef.current[0]) return;
    const cardWidth = cardsRef.current[0].offsetWidth;
    containerRef.current.style.transform = `translateX(-${currentIndex * (cardWidth + 20)}px)`;
  }, [currentIndex, cardsPerView]);

  const next = () => {
    if (currentIndex < cardData.length - cardsPerView) {
      setCurrentIndex((i) => i + 1);
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((i) => i - 1);
    }
  };

  // Don't render if no rules
  if (cardData.length === 0) {
    return null;
  }

  // Check if we need navigation buttons
  const showButtons = cardData.length > cardsPerView;

  return (
    <div className="slider-container">
      <div className="slider-header RULESHEAD">
        <div className="AB_title howtoplayBTN">
          <img src={howtoplay} alt="" className="howtoplay" /> How To Play
        </div>
      </div>

      {showButtons && (
        <button
          className="slider-btn prev"
          onClick={prev}
          disabled={currentIndex === 0}
        >
          <img src={howtoplayBTN} alt="" className="howtoplayBTNLedt" />
        </button>
      )}

      <div className="slider-wrapper">
        <div
          className={`cards-container ${showButtons ? "" : "addclass"}`}
          ref={containerRef}
        >
          {cardData.map((item, i) => (
            <div
              className="card"
              key={i}
              ref={(el) => (cardsRef.current[i] = el)}
            >
              {/* Display rule image if available */}
              {item.image ? (
                <div className="card-image-wrapper">
                  <img 
                    // src={custom} 
                    src={item.image} 

                    alt={`Rule ${item.no}`}
                    className="card-image"
                    onError={(e) => {
                      // Hide image if it fails to load
                      e.currentTarget.style.display = 'none';
                    }}
                  />
                </div>
              ) : (
                <div
                  className="card-placeholder"
                  style={{ background: `linear-gradient(135deg, #667eea ${i * 10}%, #764ba2 ${100 - i * 10}%)` }}
                />
              )}
              
              <div className="cardCont">
                <div className="card-number">{item.no}</div>
                <p className="card-text">
                  {item.text} 
             
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    <div className="btnmobile">
        <div className="btnONE">
         <button
          className="slider-btn2 prev"
          onClick={prev}
          disabled={currentIndex === 0}
        >
          <img src={howtoplayBTN} alt="" className="howtoplayBTNLedt" />
        </button>
        </div>
          <div className="btnTwo">
      <button
          className="slider-btn2 next"
          onClick={next}
          disabled={currentIndex >= cardData.length - cardsPerView}
        >
          <img src={howtoplayBTN} alt="" className="howtoplayBTNRight" />
        </button>
        </div>
        </div>
      {showButtons && (
        <button
          className="slider-btn next"
          onClick={next}
          disabled={currentIndex >= cardData.length - cardsPerView}
        >
          <img src={howtoplayBTN} alt="" className="howtoplayBTNRight" />
        </button>
      )}
    </div>
  );
}